module.exports = __webpack_public_path__ + "static/media/0030_IMG_LE_PRIMEUR.19a2660a.webp";